import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import { Button } from "@lumika/ui";
import { notificationsApi } from "../api/notifications";
import { NotificationsModal } from "./NotificationsModal";

/**
 * Bell icon for the app chrome. Carries an unread dot and opens the
 * notifications feed in a modal on click. The unread count is polled on
 * a gentle interval so the dot stays current without a socket.
 */
export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const countQuery = useQuery({
    queryKey: ["notifications", "count"],
    queryFn: () => notificationsApi.count(),
    refetchInterval: 60_000,
  });
  const unread = countQuery.data?.unread ?? 0;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        aria-label={
          unread > 0
            ? `Notification feed, ${unread} unread`
            : "Notification feed"
        }
        onClick={() => setOpen(true)}
        // Desktop chrome runs on a 32px control rhythm (search pill, New
        // conversation, user menu); shrink the bell to match at sm+ while
        // keeping the 44px mobile touch target from the icon variant.
        className="relative sm:h-8 sm:w-8"
      >
        <Bell className="h-5 w-5" />
        {unread > 0 && (
          // Blue (brand primary) unread dot — matches the unread markers
          // in the notifications feed so the signal reads consistently.
          <span
            className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-primary ring-2 ring-card"
            aria-hidden
          />
        )}
      </Button>
      <NotificationsModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
